import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateMeterArg, UpdateMeterResponse } from 'lib/services';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useUpdateMeter = (): UseMutationResult<UpdateMeterResponse, unknown, UpdateMeterArg> => {
  const notify = useAppNotifications();
  const queryClient = useQueryClient();
  const {
    backendGateway: { meters },
  } = useServices();

  return useMutation({
    mutationFn: async (args: UpdateMeterArg) => await meters.update(args),
    mutationKey: MUTATION_KEYS.meters.updateOne(),
    onError: error => {
      notify.error({
        message: 'There was an error while updating meter',
        description: error instanceof Error ? error.message : undefined,
      });
    },
    onSuccess: () => {
      notify.success({
        message: `Meter updated`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.meters.all());
    },
  });
};
